import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { List } from 'immutable';
import { BaseDataService, BaseUpdateComponent, DatePickerPopup2Component, ModalService, NotificationService, QueryParameter } from 'yt-ng-framework';
import { PodVrstaDokumentaStavkaView } from '../podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-view';
import { KomitentUgovor } from './komitent-ugovor';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-komitent-ugovor-update',
  templateUrl: './komitent-ugovor-update.component.html'
})
export class KomitentUgovorUpdateComponent extends BaseUpdateComponent<KomitentUgovor> implements OnInit {

  podvrstaDokumentaGn : string = null;
  
  
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService


  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService, modalService)
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("OrgJedID", Validators.required, 'required', 'KOMITENTUGOVOR.ORGJED.VALIDATION.REQUIRED');
    this.addValidatorToFc("PodVrstaDokumentaStavkaID", Validators.required, 'required', 'KOMITENTUGOVOR.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED');
    this.addValidatorToFc("KomitentID", Validators.required, 'required', 'KOMITENTUGOVOR.KOMITENT.VALIDATION.REQUIRED');
    this.addValidatorToFc("BrojDokumenta", Validators.required, 'required', 'KOMITENTUGOVOR.BROJDOKUMENTA.VALIDATION.REQUIRED');
    this.addValidatorToFc("BrojDokumenta2", Validators.required, 'required', 'KOMITENTUGOVOR.BROJDOKUMENTA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Datum", Validators.required, 'required', 'KOMITENTUGOVOR.DATUM.VALIDATION.REQUIRED');
    this.addValidatorToFc("OdDatuma", Validators.required, 'required', 'KOMITENTUGOVOR.ODDATUMA.VALIDATION.REQUIRED');
    


    this.IDProcessed
    .subscribe((value) =>{
      if(value && this.Item.ID == -1){
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
        this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
        this.baseFormGroup.get('BrojDokumenta').enable();
        this.baseFormGroup.get('BrojDokumenta').updateValueAndValidity();
        this.baseFormGroup.get('Datum').enable();
        this.baseFormGroup.get('Datum').updateValueAndValidity();
        let dateNow = new Date();
        let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
        this.baseFormGroup.patchValue({ Datum: date });
        this.baseFormGroup.get('Datum').updateValueAndValidity();
      }
      else{
        this.disableControls();
      }
    })
  }

  disableControls(){
    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').disable();
    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
    this.baseFormGroup.get('BrojDokumenta').disable();
    this.baseFormGroup.get('BrojDokumenta').updateValueAndValidity();
  }


  onPodVrstaSelect(value: PodVrstaDokumentaStavkaView) {
    if (value !=null){
        this.getBrojDokumenta();
        if(!this.modelData.MainList.LoadFormControlDataOnInit)
            this.getFormControlData('lookups/komitentugovor', this.fc.PodVrstaDokumentaStavkaID.value);
        this.podvrstaDokumentaGn = value.PodvrstaDokumentaGn;
    }
}

getBrojDokumenta() {
  let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
  let datum = this.baseFormGroup.get('Datum').value;
  if (this.Item.ID == -1 && podvrstaid && datum){
      this.baseDataService.GetData('KomitentUgovor', 'KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
          .subscribe(data => {
              this.baseFormGroup.patchValue({ BrojDokumenta: data });
              this.baseFormGroup.get('BrojDokumenta').updateValueAndValidity();
          })
  }
}
  
}
